export const Button = ({
  text,
  classe,
  evento,
  Icon,
  direction = "left",
  ...buttonProps
}) => {
  return (
    <button onClick={evento} className={`button ${classe}`} {...buttonProps}>
      {direction === "left" && Icon && <Icon className="button__icon" />}
      {text && <p>{text}</p>}
      {direction === "right" && Icon && <Icon className="button__icon" />}
    </button>
  );
};
